__turbopack_context__.v({
  "Description": "LegacyFlowScreen-module-scss-module__GkUCOW__Description",
  "LogoEmblem": "LegacyFlowScreen-module-scss-module__GkUCOW__LogoEmblem",
  "PromoName": "LegacyFlowScreen-module-scss-module__GkUCOW__PromoName",
  "Title": "LegacyFlowScreen-module-scss-module__GkUCOW__Title",
  "TitleContent": "LegacyFlowScreen-module-scss-module__GkUCOW__TitleContent",
  "Wrapper": "LegacyFlowScreen-module-scss-module__GkUCOW__Wrapper",
});
